import { render, staticRenderFns } from "./ModalContainer.vue?vue&type=template&id=422d6b22"
import script from "./ModalContainer.vue?vue&type=script&lang=ts"
export * from "./ModalContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports